import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField,Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import { InfluencerFormTypeSelectInput } from '../../UI/Input/SelectInput'
import DownloadIcon from '@material-ui/icons/GetApp';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <InfluencerFormTypeSelectInput source="form_type" label="Form Type" alwaysOn/>
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props)=>{
    const record = useRecordContext();  
    return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event)=>event.stopPropagation()} />
  )}


const InfluencerBusinessRequestList = ({ ...props }) => {

    return (
        <List {...props} title="Influencer" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                
                <ProfileidFiled source="profile_id" label="Profile Id" />  
                <TextField source='name' label="name" />
                 <TextField source='email' label="Email" />
                  <TextField source='form_type' label="Form Type" />
                 <TextField source='telegram_id' label="Telegram ID" />
                 <TextField source='phone' label="Phone" />
                {/* <TextField source="title" label="Title" />
                <TextField source="description" label="Description" /> */}
              <TextField source="agree_to_continue" label="Agree to Continue" />
              <TextField source="pre_team_type" label="Pre-Team Type" />
              <TextField source='commends' label="Commends" />
                <TextField source='created_at' label="Created At" />
               
<EditButton />
            </Datagrid>

        </List>
    )
}


export default InfluencerBusinessRequestList